import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { requestOtp, loginRegisterVerifyOtp } from "../api/AuthApi.services";
import "./LoginModal.css";

const LoginModal = ({ onClose, onLoginSuccess }) => {
  const [modalStep, setModalStep] = useState("LOGIN");
  const [email, setEmail] = useState("");
  const [otpError, setOtpError] = useState("");
  const [resendDisabled, setResendDisabled] = useState(false);

  const { register, handleSubmit, formState: { errors }, reset } = useForm();

  // Send OTP API Call
  const handleSendOtp = async (data) => {
    try {
      const response = await requestOtp(data);
      setEmail(data.email);
      console.log("OTP requested successfully:", response);
      reset();
      setModalStep("VERIFY_OTP"); // Switch to OTP step
    } catch (error) {
      console.error("Failed to request OTP:", error);
    }
  };

  // Verify OTP API Call
  const handleVerifyOtp = async (data) => {
    try {
      const payload = { email, otp: data.otp };
      const response = await loginRegisterVerifyOtp(payload);

      if (response && response.tokens) {
        // Store tokens
        localStorage.setItem("accessToken", response.tokens.access);
        localStorage.setItem("refreshToken", response.tokens.refresh);

        console.log("OTP verified successfully. Token stored.");

        // Close modal and proceed to checkout
        onLoginSuccess();
        onClose();
      } else {
        throw new Error("Invalid OTP");
      }
    } catch (error) {
      console.error("Failed to verify OTP:", error);
      setOtpError("Invalid OTP. Please try again.");
    }
  };

  // Resend OTP
  const handleResendOtp = async () => {
    try {
      setResendDisabled(true);
      const response = await requestOtp({ email });
      console.log("OTP resent successfully:", response);

      // Enable button after 30 seconds
      setTimeout(() => setResendDisabled(false), 30000);
      setOtpError(""); 
    } catch (error) {
      console.error("Failed to resend OTP:", error);
      setOtpError("Failed to resend OTP. Try again later.");
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="login-modal" onClick={(e) => e.stopPropagation()}> 
        {/* Stop event bubbling when clicking inside modal */}
        <button className="close-button" onClick={onClose}>✖</button>

        {modalStep === "LOGIN" ? (
          <div>
            <h3>Login/Register</h3>
            <form onSubmit={handleSubmit(handleSendOtp)}>
              <input
                type="text"
                placeholder="Email or Phone"
                {...register("email", {
                  required: "Email or phone is required",
                  pattern: {
                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$|^\d{10}$/,
                    message: "Enter a valid email or phone number",
                  },
                })}
              />
              {errors.email && <p className="error">{errors.email.message}</p>}
              <button type="submit">Send OTP</button>
            </form>
          </div>
        ) : (
          <div>
            <h3>Verify OTP</h3>
            <form onSubmit={handleSubmit(handleVerifyOtp)}>
              <input
                type="number"
                placeholder="Enter OTP"
                {...register("otp", {
                  required: "OTP is required",
                  minLength: { value: 6, message: "OTP must be 6 digits" },
                  maxLength: { value: 6, message: "OTP must be 6 digits" },
                  pattern: { value: /^\d{6}$/, message: "OTP must be numeric" },
                })}
              />
              {errors.otp && <p className="error">{errors.otp.message}</p>}
              {otpError && <p className="error">{otpError}</p>}
              <button type="submit">Verify OTP</button>
            </form>

            <button onClick={handleResendOtp} disabled={resendDisabled}>
              {resendDisabled ? "Resend OTP in 30s" : "Resend OTP"}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default LoginModal;
